import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdminService, CertService, DocumentService, IvSignService, OperationService } from './api';
import { EnvironmentService } from './api/api/environment.service';
import { ApiWebService } from './api/api/ApiWebService';
import { UserService } from './api/api/user.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CreditsService } from './base/services/credits/credits.service';
import { PersonalizationsService } from './base/services/personalizations/personalizations.service';
import { DataPercentageModule } from './components/data-percentage/data-percentage.module';
import { ColorsService } from './core/colors/colors.service';
import { CoreModule } from './core/core.module';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { FormCheckService } from './core/guards/form-check.service';
import { LoginGuardService } from './core/guards/login-guard.service';
import { PublicGuardService } from './core/guards/public-guard.service';
import { PublicRedirectGuardService } from './core/guards/public-redirect-guard.service';
import { RoleGuardService } from './core/guards/role-guard.service';
import { ProfileService } from './core/profile/profile.service';
import { TRANSLATION_PROVIDERS, TranslateService } from './core/translation';
import { CustomMatPaginatorIntl } from './core/translation/mat-paginator-intl';
import { FinishProModule } from './finish-pro/finish-pro.module';
import { CertificateService } from './finish/services/certificate.service';
import { FooterComponent } from './footer/footer.component';
import { LoginModule } from './login/login.module'
import { RegisterModule } from './register/register.module';
import { LanguagesModule } from './shared/languages/languages.module';
import { LoadingService } from './shared/loading/loading.service';
import { LogInRouteModule } from './shared/log-in-route/log-in-route.module';
import { MessageService } from './shared/message/message.service';
import { SamlService } from './services/saml.service';
import { ContactService } from './api/api/contact.service';
import { SharedModule } from './shared/shared.module';
import { DialogBrandingComponent } from './shared/dialog/signaturit/dialog-branding/dialog-branding.component';
import { VersionService } from './services/version.service';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";

function loadRemoteEnv(personalization) {
    return new Promise<boolean>((resolve) => {
        setTimeout(async () => {
            await personalization.getEnvconfig();
            resolve(true)
        }, 1000);
    });
}

export function startupServiceFactory(p: PersonalizationsService): Function {
    return () => loadRemoteEnv(p);
}

@NgModule({
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        CoreModule,
        LoginModule,
        LanguagesModule,
        LogInRouteModule,
        RegisterModule,
        MatToolbarModule,
        DataPercentageModule,
        FinishProModule,
        SharedModule
    ],
    declarations: [
        AppComponent,
        FooterComponent,
        DialogBrandingComponent
    ],
    exports: [
    ],
    providers:
        [{
            provide: APP_INITIALIZER,
            useFactory: startupServiceFactory,
            deps: [PersonalizationsService, EnvironmentService, Sentry.TraceService],
            multi: true
        },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
            TRANSLATION_PROVIDERS,
            TranslateService,
            ColorsService,
            ProfileService,
            LoadingService,
        { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        }, {
            provide: Sentry.TraceService,
            deps: [Router],
        },
            AuthGuardService,
            RoleGuardService,
            PublicRedirectGuardService,
            PublicGuardService,
            MessageService,
            CertService,
            CertificateService,
            CreditsService,
            FormCheckService,
            LoginGuardService,
            UserService,
            OperationService,
            DocumentService,
            EnvironmentService,
            VersionService,
            ApiWebService,
            SamlService,
            IvSignService,
            ContactService,
            AdminService
        ],
    bootstrap: [AppComponent]
})
export class AppModule { }
